// Bouwt de lijst voor de account-switcher uit ruwe CompagnyMeta-documenten.
//
// Voor gewone gebruikers zijn dat de omgevingen waar ze lid van zijn. Een
// superadmin krijgt álle omgevingen aangeleverd — die kan met een tijdelijke
// sessie ook omgevingen openen waar hij geen teamlid van is, en moet ze dus
// kunnen kiezen.
//
// AI-CONTEXT: See docs/features/superadmin-tenant-access.md

// Statuses that should be hidden from the account switcher.
const HIDDEN_STATUSES = ['inactive', 'archived']

const buildAccountList = (docs, { currentId, memberOf = [] } = {}) => {

    const members = Array.isArray(memberOf) ? memberOf : []

    const mapped = (Array.isArray(docs) ? docs : [])
        .filter(doc => doc && typeof doc.CompagnyID === 'string' && doc.CompagnyID !== '')
        .map(doc => ({
            // Naamloze omgevingen bestaan: val terug op het ID, anders klapt
            // het sorteren om en verdwijnt de regel uit de lijst.
            communityName: doc.CommunityName || doc.CompagnyID,
            communityID: doc.CompagnyID,
            status: (doc.Status || '').toLowerCase().trim(),
            isMember: members.includes(doc.CompagnyID),
            // Alleen `completed === false` telt: legacy-omgevingen hebben
            // helemaal geen OnboardingStatus en die zijn gewoon in gebruik.
            onboardingUnfinished: doc.OnboardingStatus?.completed === false,
        }))

    // Verborgen statuses en afgebroken aanmeldingen eruit, behalve de omgeving
    // waar je nu in zit. Een signup die halverwege is blijven steken heeft geen
    // naam en geen inhoud; die hoort niet in een keuzelijst.
    const visible = mapped.filter(item =>
        item.communityID === currentId
        || (!HIDDEN_STATUSES.includes(item.status) && !item.onboardingUnfinished)
    )

    const unique = Array.from(
        new Map(visible.map(item => [item.communityID, item])).values()
    )

    unique.sort((a, b) => a.communityName.localeCompare(b.communityName))

    return unique
}

export { HIDDEN_STATUSES }
export default buildAccountList
